<template>
  <ViewEntityContainer :entityName="entityName" :identifier="$route.params.counterId" :getMethod="getCounterById"
    :refreshOnTimestamp="true" :notificationListeners="[srEventKey]" :notificationValidator="notificationValidator">
  </ViewEntityContainer>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import ViewEntityContainer from "@/views/pim/suppliers/ViewEntityContainer.vue";
import EntityNames from "@/helpers/Constants/EntityNames.js";

export default {
  name: "ViewCounterContainer",
  components: {
    ViewEntityContainer,
  },
  mixins: [clientAPI],

  data() {
    return {
      entityName: EntityNames.Counter
    };
  },

  methods: {
    notificationValidator(args, identifier) {
      return args && args.counterId == identifier;
    },
  },

  computed: {
    srEventKey() {
      return SRConst.EventKeys.CounterChange;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>